/**
 * Compliance configuration is deliberately pure. Consumers can adopt it
 * without changing their clock, database, or request lifecycle behaviour.
 */
export * from './registry';
export * from './resolver';
